module.exports = __webpack_public_path__ + "static/fastbreak_logo-d6df78ae72d4b06d356dddd80c0a21a5.png";